module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/characters/apprenticeCurious-3e7236cce83cb89c2edaeb8503ed9211.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/characters/apprenticeCurious.png
// module id = 2258
// module chunks = 2